module.exports = __webpack_public_path__ + "img/ic_foot_hight_1.d903f365.png";